import React from 'react';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import Routes from 'src/config/routes';

const AlphabetLinks = () => {
  const alphaList = 'abcdefghijklmnopqrstuvwxyz'.split('');
  alphaList.splice(0, 0, '0-9');
  return alphaList.map((letter, index) => (
    <ExternalLink
      key={index}
      destination={`${Routes.FRANCHISE_DIRECTORY}${letter.toLowerCase()}`}
    >
      {letter.toUpperCase()}
    </ExternalLink>
  ));
};

export default AlphabetLinks;
